<template>
	<div class="com-no-data">
		<div class="no-data-img" :style="{width: width ? width+'px' : noDataTips[type].imgWidth+'px', height: height ? height+'px' :noDataTips[type].imgHeight+'px'}">
			<img class="img" :src="noDataTips[type].img" />
		</div>
		<div class="no-data-desc">{{ text ? text : noDataTips[type].text }}</div>
	</div>

</template>

<script>
	export default {
		name: 'NoData',
		props: {
			type: {
				type: Number,
				default: 4
			},
			height: {
				type:  Number,
				default: null
			},
			width: {
				type:  Number,
				default: null
			},
			text: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				noDataTips : {
					1: {
						typeDesc: '收藏',
						img: require('../assets/img/tips/collection.png'),
						imgHeight: 113,
						imgWidth:  160,
						text: '呀，这里是空的'
					},
					2: {
						typeDesc: '开票',
						img: require('../assets/img/tips/bill.png'),
						imgHeight: 116,
						imgWidth:  120,
						text: '暂无可开票订单'
					},
					3: {
						typeDesc: '优惠券',
						img: require('../assets/img/tips/coupon.png'),
						imgHeight: 123,
						imgWidth:  160,
						text: '没有可用的优惠券'
					},
					4: {
						typeDesc: '消息',
						img: require('../assets/img/tips/msg.png'),
						imgHeight: 131,
						imgWidth:  160,
						text: '呀，这里是空的'
					},
					5: {
						typeDesc: '政策大厅',
						img: require('../assets/img/tips/search.png'),
						imgHeight: 113,
						imgWidth:  160,
						text: '未搜索到相关结果'
					}
				}
			}
		},

	};
</script>

<style lang="less" scoped>
	.com-no-data {
		margin-top: 120px;
		display: flex;
		align-items: center;
		flex-direction: column;
		.no-data-img {
			img {
				width: 100%;
				height: 100%;
			}
		}
		.no-data-desc {
			margin-top: 10px;
			font-size:14px;
			font-weight:400;
			color: @subBlack;
			line-height:14px;
		}
		// 采用此种写法是为了解决图片大小自适应
		/*.background_img1 {*/
			/*width: 113px;*/
			/*heght: 160px;*/
		/*}*/
	}

</style>
